// A trace's reading as the chat shows it (read_trace_calls' and
// session_reading's details, lib/chatSubject.js: { ref, totals, rows, more }):
// what the judges read and ruled, then each call where they disputed a
// drafted claim, with why, or found work the drafts missed, with the words it
// rests on. The trace itself marks every call it read.

const META = "text-[11px] leading-[1.3]";
const OK = "var(--ok, #7fc9a3)";
const AMBER = "var(--amber, #b8860b)";

export default function ReadingCard({ details }) {
  const t = details?.totals;
  if (!t) return null;
  const rows = Array.isArray(details.rows) ? details.rows : [];
  const head = [
    `${t.calls || 0} call${t.calls === 1 ? "" : "s"} read`,
    `${t.accepted || 0} claim${t.accepted === 1 ? "" : "s"} kept`,
    `${t.rejected || 0} disputed`,
    `${t.additions || 0} missed`,
  ].join(" \u00b7 ");
  return (
    <div data-reading-card="" className="grid min-w-0 rounded-[2px] border border-[color:var(--line-soft)]">
      <div className={`${META} flex min-w-0 items-baseline gap-[8px] border-b border-[color:var(--line-soft)] px-[9px] py-[5px] text-[color:var(--muted)]`}>
        {details.ref ? <span className="shrink-0 text-[color:var(--ink)]">{details.ref}</span> : null}
        <span className="min-w-0 truncate tabular-nums">{head}</span>
      </div>
      {rows.length ? rows.map((r, i) => (
        <div key={i} data-reading-card-call="" className="grid min-w-0 gap-[2px] border-b border-[color:var(--line-soft)] px-[9px] py-[5px] last:border-b-0">
          <span className={`${META} truncate text-[color:var(--muted)]`}>{[r.turn != null ? `Turn ${r.turn}` : null, r.call].filter(Boolean).join(" \u00b7 ")}</span>
          {(r.disputed || []).map((d, j) => (
            <span key={`d${j}`} className="min-w-0 text-[12px] leading-[1.45] text-[color:var(--ink)] [overflow-wrap:anywhere]">
              <span style={{ color: AMBER }}>disputed </span>
              <span className="font-mono">{d.claim}</span>
              {d.why ? <span className="text-[color:var(--muted)]">{` - ${d.why}`}</span> : null}
            </span>
          ))}
          {(r.missed || []).map((m, j) => (
            <span key={`m${j}`} className="min-w-0 text-[12px] leading-[1.45] text-[color:var(--ink)] [overflow-wrap:anywhere]">
              <span style={{ color: OK }}>missed </span>
              <span>{m.what}</span>
              {m.quote ? <span className="font-mono text-[color:var(--muted)]">{` "${m.quote}"`}</span> : null}
            </span>
          ))}
        </div>
      )) : (
        <div className={`${META} px-[9px] py-[5px] text-[color:var(--muted)]`}>Nothing disputed, and nothing the drafts missed.</div>
      )}
      {details.more > 0 ? (
        <div className={`${META} px-[9px] py-[5px] text-[color:var(--muted)]`}>{`${details.more} more call${details.more === 1 ? "" : "s"} with a dispute or a miss`}</div>
      ) : null}
    </div>
  );
}
